import {
  CREATE_TSV_FAILURE,
  CREATE_TSV_REQUEST,
  CREATE_TSV_SUCCESS,
  HIDE_CREATE_TSV_MODAL,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: [],
    error: false,
  };
};

const initialState = getInitialState();

const tsv = (state = initialState, action) => {
  const types = {
    [CREATE_TSV_REQUEST]: () => ({
      ...state,
      isLoading: true,
      error: false,
    }),
    [CREATE_TSV_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
    }),
    [CREATE_TSV_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: action.message,
    }),
    [HIDE_CREATE_TSV_MODAL]: () => ({
      ...state,
      isLoading: false,
      error: false,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default tsv;
